import { useAuthStore } from "@/context/auth/AuthContext";
import type { PosCajeroConPin, PosEntradaConPin } from "@/platform/types";
import { entrarElCajero } from "./cajeroDeLaCaja";
import { rutaDeLaCaja, usuarioDeLaCaja } from "./sesionDeCaja";

/**
 * Entra a la caja sin sesión con el cajero que dio bien su PIN (#346 AC-2;
 * §2.6): la app queda con el usuario local de la caja y con ese cajero.
 * Devuelve a dónde ir: el mostrador del local de la caja.
 */
export function entrarALaCaja(
  entrada: PosEntradaConPin,
  cajero: PosCajeroConPin
): string {
  entrarElCajero(entrada.businessId, cajero);
  useAuthStore.setState({
    user: usuarioDeLaCaja(entrada, cajero),
    loading: false,
  });
  return rutaDeLaCaja(entrada);
}
